import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, NgForm } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { Observable } from 'rxjs';
import { CommonService } from '../core/common.service';
import { DEFAULT_INLINE_Mail_TMPL_EDITOR_TOOLBAR_CONFIG, DEFAULT_INLINE_TMPL_EDITOR_TOOLBAR_CONFIG, DEFAULT_TMPL_EDITOR_TOOLBAR_CONFIG, ToastService } from '../core';
import { finalize, map } from 'rxjs/operators';
import { DocumentUploadService } from '../core/document-upload.service';
import { AttachmentUploadService } from 'src/app/core/attachment-upload.service';
import { AuthService } from 'src/app/core/auth.service';
import { isNullOrUndefined } from '../../app/core/utils';
import { EmailApi,
    EmailAttachments, EmailMessage, EmailTemplate,
    EmailTemplateEditorInfo, HttpStatusCode, LookupField,
    PBApi
} from '../core/api.gen';

import { DialogService } from '../core/dialog.service';
import { LoaderService } from '../core/loader.service';
import { getCheckboxField, getSelectField, getTeplateSelectField, setAsHiddenWhen, setAsRequired, setDisableWhen } from '../shared/form/form-utils';
import { LookupTypeKeys } from '../shared/lookup-type-keys';
import { nullSafe } from 'src/app/utils';
@Component({

  selector: 'eos-template-generator',
  templateUrl: './template-generator.component.html',
  styleUrls: ['./template-generator.component.css']
})
export class TemplateGeneratorComponent implements OnInit {

  empCategories$: Observable<LookupField[]>;
  officeLocations$: Observable<LookupField[]>;
  onBoardingTypes$: Observable<LookupField[]>;
  templates$: Observable<EmailTemplate[]>;
  form = new UntypedFormGroup({});
  model: any = {};
  options: FormlyFormOptions = {};
  fields: FormlyFieldConfig[];
  emailMessage: EmailMessage = new EmailMessage();
  fileDetails: EmailAttachments;
  selectedDocument: File;
  isDisabled = false;

  @ViewChild('fileField', { static: true }) element: ElementRef;
  @ViewChild('fileControl', { static: true }) fileEle: ElementRef;
  @ViewChild('f', { static: true }) forms: NgForm;

  disableUpload = false;
  uploadedFiles: EmailAttachments[] = [];


  candidateID: any;

  readonly allowedMineTypes = [
    'application/pdf'
    , 'image/jpeg'
    , 'image/png'
    , 'application/msword'
    , 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    , 'application/vnd.ms-excel'
    , 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ];
  readonly MAX_FILE_SIZE: number = 10 * 1024 * 1024;
  readonly MIN_FILE_SIZE: number = 1 * 1024;


  toolbarConfig = { ...DEFAULT_TMPL_EDITOR_TOOLBAR_CONFIG };

  inlineToolbarConfig = { ...DEFAULT_INLINE_TMPL_EDITOR_TOOLBAR_CONFIG };
  inlineMailToolbarConfig = { ...DEFAULT_INLINE_Mail_TMPL_EDITOR_TOOLBAR_CONFIG };


  constructor(
    private emailApi: EmailApi,
    private _pbApi: PBApi,
    private common: CommonService,
    private documentUploadService: DocumentUploadService,
    private loader: LoaderService,
    private toast: ToastService,
    private attachmentUploadService: AttachmentUploadService,
    public authService: AuthService,
    private location: Location,
    private dialog: DialogService) {

  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.officeLocations$ = this.common.prepareLookupObservable(LookupTypeKeys.OFFICE_LOCATION);
    this.empCategories$ = this.common.prepareLookupObservable(LookupTypeKeys.EMPLOYEE_CATEGORY_TYPES);
    this.onBoardingTypes$ = this.common.prepareLookupObservable(LookupTypeKeys.ONBOARDING_TYPES);
    this.fileDetails = new EmailAttachments();
    this.model = { showSysTemplates: false, iswso: false,showWebJobTemplates:false };
    this.initFormFields();
  }

  resetModel(showSys: boolean,showWJ: boolean) {
    this.model = { showSysTemplates: showSys, iswso: false, showWebJobTemplates: showWJ};
  }

  back() {
    this.location.back();
  }

  initFormFields() {

    this.fields = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
    
getCheckboxField(
  "showSysTemplates", 
  'Show System Templates', 
  (y) => {
    this.resetModel(y, this.model.showWebJobTemplates);
    if (y) {
      this.model.showWebJobTemplates = false;  
    }
  }
),setAsHiddenWhen((m) => m.showWebJobTemplates), 

      // getCheckboxField(
      //  "showWebJobTemplates", 
      //  'Show WebJob Templates', 
      //  (y) => {
      //    this.resetModel(this.model.showSysTemplates, y);
      //    if (y) {
      //      this.model.showSysTemplates = false; 
      //    }
      //  }
      // ),setAsHiddenWhen((m) => m.showSysTemplates) , 

          getTeplateSelectField(
            "emailTemplateinfoSysTemp",
            "System template", this.common.getSystemEmailTemplateSelectFieldOptions((x) => this.onTemplateSelected(x),
              setAsRequired(setAsHiddenWhen((m) => !m.showSysTemplates)))
          ),
          getTeplateSelectField(
            "emailTemplateinfoWebJobTemp",
            "WebJob template", this.common.getWebJobEmailTemplateSelectFieldOptions((x) => this.onTemplateSelected(x),
              setAsRequired(setAsHiddenWhen((m) => !m.showWebJobTemplates)))
          ),
        
     ] },
        {
          fieldGroupClassName: 'row',
          fieldGroup: [
          getSelectField(
            "employeeCategory.id",
            "Employee category", 
            this.common.getSelectFieldOptions(this.empCategories$, '', 
              setAsRequired(
                setAsHiddenWhen(
                  (m) => m.showSysTemplates || m.showWebJobTemplates  
                )
              )
            )
          ),

          getSelectField(
            "officeLocation.id",
            "Office location", this.common.getSelectFieldOptions(this.officeLocations$.pipe(map(item => item.filter(i => ![4859].includes(i.id)))), '', setAsRequired(setAsHiddenWhen((m) => m.showSysTemplates||m.showWebJobTemplates)))
          ),

        ],
      },
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          getSelectField(
            "onboardingType.id",
            "Pre-boarding type",
            this.common.getSelectFieldOptions(this.onBoardingTypes$, '', setAsRequired(setAsHiddenWhen((m) => m.showSysTemplates|| m.showWebJobTemplates)))
          ),
          getCheckboxField("iswso", 'Is Transfer type within the same office?', null, setAsHiddenWhen((m) => m.showSysTemplates|| m.showWebJobTemplates, setDisableWhen((model) =>![717,5972].includes(nullSafe<number>(() => model['employeeCategory'].id, -1))))),
          getTeplateSelectField(
            "emailTemplateinfo",
            "Template", this.common.getEmailTemplateSelectFieldOptions((x) => this.onTemplateSelected(x),
              setAsRequired(setAsHiddenWhen((m) => m.showSysTemplates|| m.showWebJobTemplates  )))
          ),
        ],
      },
      // { template: '<hr />' },
    ];
  }

  onTemplateSelected(template: EmailTemplateEditorInfo) {
    this.LoadTemplateContent(template);
  }


  onSave(f: NgForm) {
    if (f.invalid) {
      this.toast.error("Only semicolon seperation is allowed and usage of seperation at the beginning is restricted in the To,CC and BCC Field.");
      return;
    }
    if (nullSafe(() => this.emailMessage.activityTemplateId, -1) > 0) {
      this.loader.show();
      this.emailApi.saveEmailTemplate(this.emailMessage)
        .pipe(finalize(() => this.loader.clear()))
        .subscribe(result => {
          //this.form.reset();
          if (result.statusCode == HttpStatusCode.Created) {
            let templateObj = new EmailTemplateEditorInfo();
            templateObj.id = !isNullOrUndefined(this.emailMessage.activityTemplateId) ? this.emailMessage.activityTemplateId : 0;
            this.LoadTemplateContent(templateObj);
            this.toast.success("Template updated successfully");
            this.uploadedFiles = [];
            this.form.markAsPristine();
          }
        }, err => {
          this.toast.serverError(err);
        });
    }
  }

  removeAttachment(id) {
    this.emailMessage.attachments.splice(this.emailMessage.attachments.indexOf(id), 1);
  }
  submit() {

  }
  get ifDocNotValid(): boolean {
    if (this.selectedDocument && (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE)) {
      return true;
    }

    return false;
  }

  browseFile() {
    // console.log(this.fileEle);
    this.fileEle.nativeElement.click();
  }

  get fileBrowserAllowedTypes() {
    return this.allowedMineTypes.join(',');
  }

  fileSelected(files: FileList) {
    // console.log(files);
    if (!files.item(0)) {
      return;
    }
    this.selectedDocument = files.item(0);

    if (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE) {

      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()} KB
		   and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);

      this.fileEle.nativeElement.value = null;
      return;
    }


    if (this.allowedMineTypes.indexOf(this.selectedDocument.type) < 0) {
      this.toast.error(`Invalid file type. Please select a valid file`);
      this.fileEle.nativeElement.value = null;
      this.selectedDocument = null;
      this.element.nativeElement.value = "";
      return;
    }

    this.fileDetails.fileName = this.selectedDocument.name;
  }

  get selectedFileName(): string {
    return nullSafe(() => this.selectedDocument.name, '');
  }

  uploadDoc(f: NgForm) {


    if (f.invalid) {
      return;
    }

    if (this.ifDocNotValid) {
      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()}
		   KB and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);
      return;
    }
    if (isNullOrUndefined(this.selectedDocument)) {
      this.toast.warning("Please select a file!");
      return;
    }
    // if (this.allFiles.some((item) => (item.fileName === this.fileDetails.fileName) && (item.id !== this.fileDetails.id))) {
    if (this.uploadedFiles.some((item) => (item.fileName === this.selectedDocument.name) && (item.id !== this.fileDetails.id))) {
      this.toast.error("Attachment Name should be unique");
      return;
    }
    if (this.form.value.showSysTemplates) {
      this.fileDetails.emailTemplateId = this.form.value.emailTemplateinfoSysTemp.id;
    } else {
      this.fileDetails.emailTemplateId = this.form.value.emailTemplateinfo.id;
    }



    this.fileDetails.createdById = this.authService.ActiveUser.employeeId;
    this.upload(f);
  }
  upload(f: NgForm) {
    f.form.disable();
    this.disableUpload = true;
    this.isDisabled = true;
    this.attachmentUploadService.postFileTemplate(this.fileDetails, this.selectedDocument).pipe(finalize(() => {
      this.selectedDocument = null;
      this.fileEle.nativeElement.value = null;
      f.form.enable();
      this.disableUpload = false;
      this.isDisabled = false;
      // f.reset({});
    }))
      .subscribe(resp => {
        // this.updateAllFiles(resp.data);
        this.element.nativeElement.value = "";
        this.toast.success("File uploaded successfully!");
        this.getUploadedAttachmentDetails(this.fileDetails.emailTemplateId);

        //this.getUploadedAttachmentDetails(this.candidate_Id, this.activity.id, this.results.activityTemplateId);
      }, error => {
        this.toast.error("Something went wrong!");
      });
    // this.GetDocumentEvent.emit(this.uploadedFiles);
  }
  deleteAttachment(fileDetails) {
    this.emailApi.deleteAttachment(fileDetails).subscribe((resp) => {
      this.toast.success("Attachment deleted!");
      this.uploadedFiles = resp;
    });
  }


  getUploadedAttachmentDetails(emailTemplateId: number) {
    this.emailApi.getAttachmentsNewDetails(emailTemplateId).subscribe(resp => {
    this.uploadedFiles = resp;
     
    });
  }

  downloadFile(fileName: string) {
    this.documentUploadService.downloadDocumentFile(fileName);
  }

  downloadAttachment(details) {
    this.attachmentUploadService.downloadAttachment(details);
  }

  LoadTemplateContent(template: EmailTemplateEditorInfo) {
    if (template && template.id > 0) {
      this.loader.show();
      this.emailApi.getEmailMessage(template.id, false).pipe(
        finalize(() => this.loader.clear())
      ).subscribe(em => {
        this.emailMessage = em;
        this.getUploadedAttachmentDetails(template.id);
        this.emailMessage.activityId = template.activityId;
      }, err => {
        this.toast.error('Error occured while loading the template');
        this.emailMessage = new EmailMessage();
      });
    } else {
      this.emailMessage = new EmailMessage();
      this.uploadedFiles = [];
    }
  }

  refreshTemplate() {
    const templateId = this.form.value.emailTemplateinfo.id;
    if (templateId > 0) {
      this.loader.show();
      this.emailApi.getEmailMessage(templateId, true).pipe(
        finalize(() => this.loader.clear())
      ).subscribe(em => {
        this.emailMessage = em;
      });
    } else {
      this.emailMessage = new EmailMessage();
    }
  }
  initiateSaveToMany(f: NgForm) {
    if (f.invalid) {
      this.toast.error("Only semicolon seperation is allowed and usage of seperation at the beginning is restricted in the To,CC and BCC Field.");
      return;
    }
    this.dialog.showTemplateDialog(this.emailMessage, this.form.controls.emailTemplateinfo.value);

  }
  sendMe() {

    if (!this.candidateID) {
      this.toast.warning("Please input a Candidate ID");
    }
    else if (!this.emailMessage.templateCode) {
      this.toast.warning('Please select an email template');
    }
    else {
      this._pbApi.getRequestType(this.candidateID).subscribe(x => {
        if (x == true) {
          this.loader.show();
          this.emailApi.getRenderedMail(this.candidateID, this.emailMessage.templateCode,this.emailMessage.activityTemplateId).pipe(
            finalize(() => this.loader.clear())
          ).subscribe(emailMessage => {
            this.dialog.loadGenMail(emailMessage, (mail) => { this.sendAsync(mail) }, 'Preview',()=>this.uploadedtemplate(
              emailMessage.activityTemplateId
            ));
          });
        }
        else {
          this.toast.warning("Please input a valid Candidate ID");
        }
      });
    }
  }
  uploadedtemplate(templateId:number)
  {
      return this.emailApi.getAttachmentsNewDetails(templateId);
  }
  sendAsync(mail): void {
    this.loader.show();
    this.emailApi.sendToSelf(this.candidateID, mail).pipe(
      finalize(() => this.loader.clear())
    ).subscribe(x => { });
  }
}

